import { Pipe, PipeTransform } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { AvatarCacheService } from '../services/avatar-cache/avatar-cache.service';

@Pipe({
  name: 'authImage',
  standalone: true,
  pure: true
})
export class AuthImagePipe implements PipeTransform {
  constructor(private avatarCache: AvatarCacheService) {}

  transform(imagePath: string | null | undefined): Observable<SafeUrl | string> {
    return this.avatarCache.getSafeUrl(imagePath);
  }
}
